import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { DisplayFieldsFragment, GetLiveDisplayQuery, useGetLiveDisplayQuery } from '../../../../../../../generated/core-api/graphql-react-query';
import useLiveContext from '../../../../../../LiveContext/useLiveContext';

export function useUpdateDisplay() {
  const queryClient = useQueryClient();
  const updateDisplay = React.useCallback((display: DisplayFieldsFragment) => {
    queryClient.setQueryData<GetLiveDisplayQuery>(['getLiveDisplay', { input: { id: display.id } }], { __typename: 'Query', getDisplay: display });
  }, [queryClient]);
  return updateDisplay;
}

export default function useDisplay() {
  const { displayId } = useLiveContext();
  const display = useGetLiveDisplayQuery({ input: { id: displayId ?? '' } }, { enabled: !!displayId });
  return display;
}
